import api from './api'
import { PaginationResponse } from '../types/api'

type ApiSuccessResponse<T> = {
  success?: boolean
  data: T
}

export interface ShippingZone {
  id: string
  name: string
  zipCodeStart: string
  zipCodeEnd: string
  shippingMethodId: string
  price: number
  estimatedDays: number
  isActive: boolean
  createdAt: string
  shippingMethod?: {
    id: string
    name: string
  }
}

export interface ShippingZoneFormValues {
  name: string
  zipCodeStart: string
  zipCodeEnd: string
  shippingMethodId: string
  price: number
  estimatedDays: number
  isActive: boolean
}

type ListParams = {
  search?: string
  isActive?: boolean
  shippingMethodId?: string
  page?: number
  limit?: number
}

export type AdminShippingZoneListResponse = {
  zones: ShippingZone[]
  pagination: PaginationResponse
}

const adminShippingZoneService = {
  async list(params: ListParams = {}): Promise<AdminShippingZoneListResponse> {
    const { search, isActive, shippingMethodId, page, limit } = params

    const queryParams: Record<string, unknown> = {}

    if (search) queryParams.search = search
    if (isActive !== undefined) queryParams.isActive = isActive
    if (shippingMethodId) queryParams.shippingMethodId = shippingMethodId
    if (page) queryParams.page = page
    if (limit) queryParams.limit = limit

    const response = await api.get<ApiSuccessResponse<AdminShippingZoneListResponse>>(
      '/admin/shipping-zones',
      { params: queryParams }
    )

    return response.data.data
  },

  async getById(zoneId: string): Promise<ShippingZone> {
    const response = await api.get<ApiSuccessResponse<ShippingZone>>(
      `/admin/shipping-zones/${zoneId}`
    )

    return response.data.data
  },

  async create(payload: ShippingZoneFormValues): Promise<ShippingZone> {
    const response = await api.post<ApiSuccessResponse<ShippingZone>>(
      '/admin/shipping-zones',
      payload
    )

    return response.data.data
  },

  async update(
    zoneId: string,
    payload: ShippingZoneFormValues
  ): Promise<ShippingZone> {
    const response = await api.put<ApiSuccessResponse<ShippingZone>>(
      `/admin/shipping-zones/${zoneId}`,
      payload
    )

    return response.data.data
  },

  async updateStatus(zoneId: string, isActive: boolean): Promise<ShippingZone> {
    const response = await api.patch<ApiSuccessResponse<ShippingZone>>(
      `/admin/shipping-zones/${zoneId}/status`,
      { isActive }
    )

    return response.data.data
  },

  async remove(zoneId: string): Promise<void> {
    await api.delete(`/admin/shipping-zones/${zoneId}`)
  }
}

export default adminShippingZoneService

